import React from 'react';
import styled from 'styled-components';
import { media, theme } from 'styles';
import { animateScroll as scroll } from 'react-scroll';
// import location from 'images/contact-location.jpg';
import bam from 'images/contact-BAM.png';
import bannerImage from 'images/banners/contact-banner.jpg';
import { Breadcrumbs, Button, Container, SeoTags } from 'components/shared';
import routes from 'helpers/routes';

const { sp, colors } = theme;

const Wrapper = styled.div`
  background-color: ${colors.blueIce};
  h2 {
    margin-bottom: ${sp.xl};
    font-size: 36px;
    line-height: 42px;
    font-weight: 700;
    color: ${colors.navy};

    ${media.tablet`
    `};
  }

  h3 {
    margin-bottom: ${sp.m};
    font-size: 24px;
    line-height: 36px;
    font-weight: 500;
    color: ${colors.royal};

    ${media.tablet`
      margin-bottom: ${sp.l};
      font-size: 28px;
      line-height: 36px;
    `};

    a {
      color: ${colors.blue};
      font-weight: 600;
    }
  }

  h4 {
    padding-top: ${sp.m};
    font-size: 24px;
    line-height: 36px;
    font-weight: 500;
    color: ${colors.cobalt};

    ${media.tablet`
      padding-top: ${sp.l};
    `};
  }
`;

const Content = styled.div`
  margin-top: 60px;

  ${media.tablet`
    margin-top: 100px;
  `};

  p {
    font-size: 24px;
    line-height: 36px;
    font-weight: 500;
    color: ${colors.royal};
  }

  img {
    display: block;
    margin: 0 auto;
    max-width: 100%;
  }
`;

/* const Location = styled.div`
  margin-bottom: 100px;

  a {
    text-decoration: none;
    color: ${colors.blue};
  }

  ${media.tablet`
    margin-bottom: 0;
  `};
`; */

const ColumnWrapper = styled.div`
  ${media.tablet`
    display: flex;
    justify-content: space-between;
  `};
`;

const Column = styled.div`
  img {
    max-width: 60%;
  }

  &:first-child {
    margin-bottom: ${sp.xxl};

    ${media.tablet`
      margin: 0;
    `};
  }

  ${media.tablet`
    width: calc(50% - 30px);

    img {
      max-width: 100%;
    }

    ${props =>
      props.nudge &&
      `
      padding-top: 22px;
    `}
  `};
`;

const Details = styled.div`
  margin-bottom: 50px;
`;

const DetailHeader = styled.div`
  max-width: 500px;
  text-align: center;
  margin: 0 auto;
`;

const DetailWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  ${media.tablet`
    flex-direction: row;
  `};
`;

const DetailWrapperItem = styled.div`
  text-align: center;

  ${media.tablet`
    text-align: initial;
  `};
`;

const Bam = styled.div`
  h3 {
    font-size: 2.2em;
    font-weight: 600;
    color: ${colors.navy};
  }
`;

const List = styled.div`
  ul,
  ol {
    counter-reset: item;
    line-height: 1.4;
    font-weight: 400;
    margin-bottom: ${sp.xxl};
  }

  ol,
  ul {
    padding: 0;
    font-size: 20px;

    ${media.tablet`
      padding: 0 0 0 30px;
    `};
  }

  ul li {
    position: relative;
    list-style: none;
    padding-left: 40px;
    margin-bottom: ${sp.s};

    &::before {
      position: absolute;
      top: 15px;
      left: 0;
      width: 20px;
      height: 2px;
      background-color: ${colors.blue};
      content: '';
    }
  }

  ol li {
    position: relative;
    counter-increment: item;
    list-style: none;
    padding-left: 40px;
    margin-bottom: ${sp.s};

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: counters(item, '') '.';
      color: ${colors.blue};
      width: 20px;
    }
  }
`;

const Banner = styled.div`
  position: relative;
  background-image: url('${props => props.src}');
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  padding: 60px 0 100px;

  ${media.tablet`
    padding: 100px 0;
  `};

  h1 {
    color: ${colors.white};
    max-width: 600px;
    font-size: 40px;
    line-height: 48px;
    letter-spacing: -0.8px;
    margin-top: ${sp.xxl};
    margin-bottom: ${sp.xxl};
    font-weight: 700;

    ${media.tablet`
      margin-top: ${sp.l};
      font-size: 60px;
      line-height: 72px;
      letter-spacing: -1.1px;
    `};
  }

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(43, 88, 153, 0.7);
    content: '';
  }

  ${media.tablet`
    background-position: top right;
    min-height: 700px;

    &::before {
      background-color: rgba(43, 88, 153, 0.3);
    }
  `};
`;

function ContactUs() {
  const breadcrumbs = [
    {
      name: 'Home',
      link: '/',
    },
    {
      name: 'Contact Us',
      link: '/contact-us',
    },
  ];

  return (
    <Wrapper>
      <SeoTags
        title="Contact Us | On Demand Marketing Services | MarketTap"
        description="Contact us to find out how we can help your e-commerce business sell more online with our our unique pay-as-you-go model. Get in touch today."
      />
      <Banner src={bannerImage}>
        <Container>
          <Breadcrumbs breadcrumbs={breadcrumbs} left light />
          <h1>
            Need Help?
            <br />
            Have a question?
          </h1>
          <Button yellow scroll onClick={() => scroll.scrollTo(500)}>
            Get in touch
          </Button>
        </Container>
      </Banner>

      <Content>
        {/* <Location>
          <Container>
            <ColumnWrapper>
              <Column>
                <iframe
                  title="Contact Form"
                  src="https://markettap58913.activehosted.com/f/11"
                  width="100%"
                  height="880"
                  type="text/html"
                  frameBorder="0"
                  allowTransparency="true"
                  style={{ border: 0 }}
                />
              </Column>
              <Column nudge>
                <img src={location} alt="" />
                <h4>Head Office:</h4>
                <p>
                  37 Front St E, Suite 200,<br />Toronto, ON, M5E 1B3
                </p>
              </Column>
            </ColumnWrapper>
          </Container>
        </Location> */}

        <Details>
          <Container>
            <DetailHeader>
              <h2 id="scrollto">
                Our team is available by phone, email, or live chat.
              </h2>
            </DetailHeader>

            <DetailWrapper>
              <DetailWrapperItem>
                <h4>Toll Free:</h4>
                <h3>+1 (866) 302-0414</h3>
              </DetailWrapperItem>

              <DetailWrapperItem>
                <h4>General:</h4>
                <h3>
                  <a href="mailto:info@markettap.com">info@markettap.com</a>
                </h3>
              </DetailWrapperItem>

              <DetailWrapperItem>
                <h4>Job Inquiries:</h4>
                <h3>
                  <a href="mailto:work@markettap.com">work@markettap.com</a>
                </h3>
              </DetailWrapperItem>
            </DetailWrapper>
          </Container>
        </Details>

        <Bam>
          <Container>
            <ColumnWrapper>
              <Column>
                <img src={bam} alt="" />
              </Column>
              <Column nudge>
                <h3>Get answers to your marketing questions - it’s free.</h3>
                <List>
                  <ul>
                    <li>Book a time slot that is most convenient for you.</li>
                    <li>
                      Type in your questions so we can make the best use of your
                      time.
                    </li>
                    <li>No credit card required for Free Consultation.</li>
                  </ul>
                </List>
                <Button yellow to={routes.bookMarketer.index}>
                  Book a call
                </Button>
              </Column>
            </ColumnWrapper>
          </Container>
        </Bam>
      </Content>
    </Wrapper>
  );
}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/pages/contact-us.js